import React, { Component } from "react";
import Header from "../components/Header_Footer/Header";
import "../components/Header_Footer/Footer/footer.scss";
import Axios from "axios";
import { connect } from "react-redux";
import * as actionTypes from "../store/actions";
import translator from "../utils/translator";

class Layout extends Component {
	componentDidMount = async () => {
		let get_translations_API_URL = this.props.APIUrl + "/language/bulk-translations";
		let get_translations_API_response = await Axios.post(get_translations_API_URL);
		await this.props.toggle_language(get_translations_API_response.data);
	};

	render() {
		return (
			<div>
				<Header />
				<div className="page_container">{this.props.children}</div>
				<div class="footer">
					&copy;{(new Date).getFullYear()} {translator("Misc", "copyright_notice")}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		searched_projects_results: state.searched_projects_results,
		APIUrl: state.APIUrl,
		selected_language_translations: state.language_translations,
		selected_language: state.selected_language
	};
};

const mapDispatchToProps = dispatch => {
	return {
		toggle_language: language_translations =>
			dispatch({
				type: actionTypes.TOGGLE_LANGUAGE,
				language_translations
			})
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
